import gql from 'graphql-tag'
import { QueryBuilder } from '../utils'
import { PaymentOrder } from '@/entities/finance'
import { ClosingReasonFragment, ProcessStatusFragment } from '@/graphql/fragments/settings'

const query = gql`
  ${ProcessStatusFragment}
  ${ClosingReasonFragment}
  query paymentOrders($filter: finance_payment_order_bool_exp, $order: [finance_payment_order_order_by!], $limit: Int, $offset: Int) {
    records: finance_payment_order(where: $filter, order_by: $order, limit: $limit, offset: $offset) {
      id
      createdAt: created_at
      amount
      person {
        id
        alias
      }
      process {
        id
        tableName: table_name
      }
      status: process_status {
        ...ProcessStatus
      }
      closingReason: closing_reason {
        ...ClosingReason
      }
      paymentSupportType: payment_support_type {
        id
        description
        color
      }
      deal {
        id
        stock {
          id
          soldDate: sold_date
        }
      }
      supportDate: support_date
      supportNumber: support_number
      idProcessRecord: id_process_record
      acquisitionType: acquisition_type {
        id
        name
        description
      }
      items {
        id
        processExpense: process_expense {
          id
          expense {
            id
            description
            type {
              id
              description
              name
              color
            }
          }
        }
        recipients {
          id
          payments {
            id
            amount
            date
            createdAt: created_at
            status {
              ...ProcessStatus
            }
            closingReason: closing_reason {
              ...ClosingReason
            }
            responsible {
              id
              person {
                id
                type {
                  name
                }
                firstName: first_name
                surname
              }
            }
            validator {
              id
              person {
                id
                type {
                  name
                }
                firstName: first_name
                surname
              }
            }
            type: payment_type {
              id
              description
              name
              color
            }
            paymentRecipient: payment_recipient {
              id
              person {
                id
                alias
              }
            }
            recipientAccount: recipient_account {
              id
              bankData: bank_data {
                id
                accountNumber: account_number
                bank {
                  id
                  alias
                }
              }
            }
          }
        }
      }
      expenseCategory: expense_category {
        id
        name
        description
        color
      }
    }
    total: finance_payment_order_aggregate(where: $filter) {
      aggregate {
        count(distinct: true)
      }
    }
  }
`

export const paymentOrders = QueryBuilder(query, PaymentOrder)
export default paymentOrders
